"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Icon2 = require("../../../Icon");
var _Icon3 = _interopRequireDefault(_Icon2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
var IconSchoolTeacher = /*#__PURE__*/
function (_Icon) {
  _inherits(IconSchoolTeacher, _Icon);
  function IconSchoolTeacher(props) {
    var _this;
    _classCallCheck(this, IconSchoolTeacher);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconSchoolTeacher).call(this, props));
    _this.name = 'IconSchoolTeacher';
    _this.icon = _react2.default.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      focusable: "false",
      "aria-hidden": "true",
      role: "presentation"
    }, _react2.default.createElement("g", {
      className: "school-teacher_svg__group0"
    }, _react2.default.createElement("path", {
      className: "school-teacher_svg__path0",
      d: "M3 24a.502.502 0 01-.498-.458L2.04 18H.5a.5.5 0 01-.5-.5V14c0-3.033 2.467-5.5 5.5-5.5S11 10.967 11 14v3.5a.5.5 0 01-.5.5H8.96l-.462 5.542A.502.502 0 018 24H3zm4.54-1l.417-5H3.043l.417 5H5v-3.5a.5.5 0 011 0V23h1.54zM10 17v-3a4.494 4.494 0 00-4-4.466V14a.5.5 0 01-1 0V9.534c-2.263.25-4 2.163-4 4.466v3h1v-2.5a.5.5 0 011 0V17h5v-2.5a.5.5 0 011 0V17h1z"
    }), _react2.default.createElement("path", {
      className: "school-teacher_svg__path1",
      d: "M5.5 8c-2.206 0-4-1.794-4-4 0-.637.149-1.25.443-1.822A3.991 3.991 0 015.5 0c1.951 0 3.649 1.456 3.948 3.386A3.912 3.912 0 019.5 4c0 2.206-1.794 4-4 4zM2.61 3.198A3.004 3.004 0 005.5 7a3.004 3.004 0 002.994-2.812 6.488 6.488 0 01-5.884-.99zm3.904.302c.636 0 1.265-.112 1.867-.332A3.015 3.015 0 005.5 1c-.985 0-1.885.473-2.449 1.275A5.46 5.46 0 006.494 3.5h.02z"
    }), _react2.default.createElement("path", {
      className: "school-teacher_svg__path2",
      d: "M13.5 18a.5.5 0 010-1h8c.827 0 1.5-.673 1.5-1.5v-13c0-.827-.673-1.5-1.5-1.5H10a.5.5 0 010-1h11.5C22.878 0 24 1.121 24 2.5v13c0 1.378-1.122 2.5-2.5 2.5h-8z"
    })));
    return _this;
  }
  return IconSchoolTeacher;
}(_Icon3.default);
exports.default = IconSchoolTeacher;